import { Accessor, JSX, createRoot, getOwner, onCleanup } from 'solid-js';
import { ActiveProvider } from '@/components/Active';

/**
 * 创建一个缓存上下文, 当组件被删除时可以重用，一般用于Show切换场景
 * @returns
 */
export default function createKeepAlive() {
  const owner = getOwner();
  let cache:
    | {
        depose(): void;
        el: JSX.Element;
      }
    | undefined = undefined;
  function render(
    el: () => JSX.Element,
    active: Accessor<boolean> = () => true
  ) {
    if (!cache) {
      cache = createRoot((depose) => {
        return {
          el: <ActiveProvider value={active()} children={el()} />,
          depose,
        };
      }, owner);
    }
    return cache.el;
  }
  onCleanup(() => {
    cache && cache.depose();
  });

  return render;
}
